export default {
  styleOverrides: {
    root: {
      "&.MuiMenu-paper": {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        "& .MuiMenu-list": {
          paddingTop: 0,
          paddingBottom: 0,
        },
      },
    },
  },
  variants: [
    {
      props: { variant: "signin" },
      style: {
        boxShadow: "0px 0px 40px 0px #0000000F",
        radius: "8px",
      },
    },
  ],
};
